import { StoreMinimalModel } from "./Store";
import { CategoryId, ProductId, ProductMinimalModel } from "./Product";

export interface AwaitingStocktakingCounts {
  storeCounts: ReadonlyArray<StoreCount>;
  storeTotalCount: number;
}

export interface StoreCount {
  store: StoreMinimalModel;
  count: number;
}

export type StoreStocktakingId = string;

export interface StoreStocktakingItem {
  id: StoreStocktakingId;
  storeId: string;
  storeName?: string;
  product: ProductMinimalModel;
  onShelfBefore?: number;
  inStorageBefore?: number;
  onShelf?: number;
  inStorage?: number;
  onShelfChanged?: boolean;
  inStorageChanged?: boolean;
  created: Date;
  searchMetaData?: string;
}

export interface StocktakingOverviewListItem {
  id: string;
  storeName: string;
  gtin: string;
  productName: string;
  categoryName: string;
  created: Date;
}

export interface CreateStocktaking {
  storeIds: ReadonlyArray<string>;
  categoryIds: ReadonlyArray<CategoryId>;
  allStores: boolean;
  allCategories: boolean;
  daysBack: number;
}

export interface LockedItem {
  id: string;
  lastUpdatedBy: string;
  updated: Date;
  gtin: string;
}

export interface ProcessedItem {
  id: string;
  lastUpdatedBy: string;
  updated: Date;
  onShelf: number;
  gtin: string;
}

export const getProductConcatName = (product: ProductMinimalModel): string => {
  let rendered = "";

  if (product.brandName) {
    rendered += product.brandName;
  }

  if (rendered) {
    rendered += ", ";
  }
  rendered += product.name;

  if (product.size) {
    if (rendered) {
      rendered += ", ";
    }

    rendered += product.size;
  }

  return rendered;
};
